module.exports = __webpack_public_path__ + "img/1.ae598d7a.png";